module.exports = __webpack_public_path__ + "img/4.43b65f7e.png";